import e from "react";
import { translate as t } from "@aws-amplify/ui";
import { Button as o } from "../../../primitives/Button/Button.js";
import { Flex as i } from "../../../primitives/Flex/Flex.js";
import { Heading as r } from "../../../primitives/Heading/Heading.js";
import { Text as n } from "../../../primitives/Text/Text.js";
import { useAuthenticator as a } from "@aws-amplify/ui-react-core";
import { useCustomComponents as m } from "../hooks/useCustomComponents/index.js";
import { useFormHandlers as l } from "../hooks/useFormHandlers/useFormHandlers.js";
import { RemoteErrorMessage as s } from "../shared/RemoteErrorMessage.js";
import { FormFields as d } from "../shared/FormFields.js";
import { RouteContainer as c } from "../RouteContainer/RouteContainer.js";
function u(_ref) {
  let {
    className: r,
    variation: p
  } = _ref;
  const {
      isPending: f,
      resendCode: y,
      codeDeliveryDetails: {
        DeliveryMedium: h,
        Destination: g
      } = {}
    } = a(e => [e.isPending, e.resendCode, e.codeDeliveryDetails]),
    {
      handleChange: v,
      handleSubmit: E
    } = l(),
    {
      components: {
        ConfirmSignUp: {
          Header: C = u.Header,
          Footer: D = u.Footer
        }
      }
    } = m(),
    j = t("Your code is on the way. To log in, enter the code we emailed to"),
    x = t("Your code is on the way. To log in, enter the code we texted to"),
    F = t("Your code is on the way. To log in, enter the code we sent you. It may take a minute to arrive."),
    w = t("It may take a minute to arrive."),
    S = "EMAIL" === h ? "".concat(j, " ").concat(g, ". ").concat(w) : "SMS" === h ? "".concat(x, " ").concat(g, ". ").concat(w) : t("".concat(F));
  return e.createElement(c, {
    className: r,
    variation: p
  }, e.createElement("form", {
    "data-amplify-form": "",
    "data-amplify-authenticator-confirmsignup": "",
    method: "post",
    onChange: v,
    onSubmit: E
  }, e.createElement(i, {
    as: "fieldset",
    direction: "column",
    isDisabled: f
  }, e.createElement(C, null), e.createElement(i, {
    direction: "column"
  }, e.createElement(n, {
    className: "amplify-authenticator__subtitle"
  }, S), e.createElement(d, null), e.createElement(s, null), e.createElement(o, {
    variation: "primary",
    isDisabled: f,
    type: "submit",
    loadingText: t("Confirming"),
    isLoading: f,
    fontWeight: "normal"
  }, t("Confirm")), e.createElement(o, {
    onClick: y,
    type: "button",
    fontWeight: "normal"
  }, t("Resend Code"))), e.createElement(D, null))));
}
u.Header = () => {
  const {
      codeDeliveryDetails: {
        DeliveryMedium: o
      } = {}
    } = a(e => [e.codeDeliveryDetails]),
    i = t("EMAIL" === o ? "We Emailed You" : "SMS" === o ? "We Texted You" : "We Sent A Code");
  return e.createElement(r, {
    level: 4
  }, i);
}, u.Footer = function () {
  return null;
};
export { u as ConfirmSignUp };